import { Font } from "components/shopFeatures/wizard/constants"
import styled from "styled-components"

export const ShopTitle = styled.h2`
  margin: 0;
  padding: 0;
  font-family: ${Font.OENaPro};
  font-size: 18px;
  font-weight: 300;
  line-height: 27px;
  letter-spacing: 0em;
`

export const ShopList = styled.ul<{ $hideBullets?: boolean }>`
  list-style-position: inside;
  padding: 0;
  ${(p) => p?.$hideBullets && "list-style-type: none;"}
`

export const ShopListItem = styled.li`
  font-family: ${Font.OENaPro};
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0em;

  ::marker {
    font-size: 18px;
    color: ${(p) => p?.theme?.colors?.darkGrey};
  }
`
